import type { AthletesModel } from "./types.js";

/** Ranking divisions always retain sex, discipline and weight class. */
export function getRankingCategoryKey(
  athlete: AthletesModel,
  isNational = false,
): string {
  return JSON.stringify([
    athlete.sexe,
    athlete.disciplineId,
    athlete.catPoidId,
    ...(isNational ? [] : [athlete.catAgeId]),
  ]);
}

export function isSameRankingCategory(
  athlete: AthletesModel,
  other: AthletesModel,
  isNational = false,
): boolean {
  return (
    getRankingCategoryKey(athlete, isNational) ===
    getRankingCategoryKey(other, isNational)
  );
}
